module.exports = __webpack_public_path__ + "img/50.21c27571.png";